module.exports = __webpack_public_path__ + "media/assets/images/flags/ke-786ea833ad01ed3f68f036ffd57ce519.svg";